import React from 'react';

import { GroupBase, components } from 'react-select';
import { MenuListProps } from 'react-select/dist/declarations/src/components/Menu';
import { OnChangeValue } from 'react-select/dist/declarations/src/types';

import classes from 'components/DesignSystem/Select/components/MenuListSelectAll/MenuListSelectAll.module.scss';

export const MenuListSelectAll = <
    Option,
    IsMulti extends boolean = boolean,
    Group extends GroupBase<Option> = GroupBase<Option>,
>({
    children,
    setValue,
    options,
    getValue,
    ...rest
}: MenuListProps<Option, IsMulti, Group>) => {
    const allSelected = options.length === getValue().length;
    const selectDeselectTitle = !allSelected ? 'Select all' : 'De-select all';
    const handleSelectDeSelectAll = () => {
        !allSelected
            ? setValue(options as OnChangeValue<Option, IsMulti>, 'select-option')
            : setValue([] as unknown as OnChangeValue<Option, IsMulti>, 'select-option');
    };

    return (
        <div>
            <div className={classes.menuListSwitchContainer}>
                <span className={classes.selectDeselectTitle} onClick={handleSelectDeSelectAll}>
                    {selectDeselectTitle}
                </span>
            </div>
            <components.MenuList setValue={setValue} options={options} getValue={getValue} {...rest}>
                {children}
            </components.MenuList>
        </div>
    );
};
